"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSessionTrackingCookies = exports.sessionTrackingProperties = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const cookieKeys = {
    sessionStatusKey: 'isLoggedIn',
    previousSessionStatusKey: 'hasLoggedInPreviously',
    landingPageKey: 'session:landingPage',
    rawLandingPageKey: 'session:rawLandingPage',
    landingLocale: 'session:landingLocale',
    metaClickId: '_fbc',
    hubspotToken: 'hubspotutk',
};
// After the user is inactive for this amount of time, we consider them to be in a new session
const SESSION_LENGTH_IN_MINUTES = 30;
const sessionTrackingProperties = () => {
    const hasCurrentSessionCookie = js_cookie_1.default.get(cookieKeys.sessionStatusKey) === 'true';
    const hasPreviousSessionCookie = js_cookie_1.default.get(cookieKeys.previousSessionStatusKey) === 'true';
    const storedLandingPage = js_cookie_1.default.get(cookieKeys.landingPageKey);
    const storedRawLandingPage = js_cookie_1.default.get(cookieKeys.rawLandingPageKey);
    const storedLandingLocale = js_cookie_1.default.get(cookieKeys.landingLocale);
    const host = window.location.host;
    const pathname = window.location.pathname;
    const [locale, ...rawPathParts] = pathname.replace(/^\//, '').split('/');
    const rawPath = rawPathParts.length ? rawPathParts.join('/') : '/';
    // If the cookie exists and hasn't expired, keep the same value.
    // Otherwise, use the path of the current page
    const landingPage = storedLandingPage || host + pathname;
    const rawLandingPage = storedRawLandingPage || rawPath;
    const landingLocale = storedLandingLocale || locale;
    return {
        landingPage,
        rawLandingPage,
        landingLocale,
        loggedInCurrently: hasCurrentSessionCookie,
        loggedInPreviously: hasPreviousSessionCookie || hasCurrentSessionCookie,
        facebookClickId: js_cookie_1.default.get(cookieKeys.metaClickId),
        hubspotutk: js_cookie_1.default.get(cookieKeys.hubspotToken),
    };
};
exports.sessionTrackingProperties = sessionTrackingProperties;
const updateSessionTrackingCookies = () => {
    const { landingPage, rawLandingPage, landingLocale, loggedInCurrently } = (0, exports.sessionTrackingProperties)();
    const expires = new Date();
    // Set the cookie expiration as `SESSION_LENGTH_IN_MINUTES` from now
    expires.setMinutes(expires.getMinutes() + SESSION_LENGTH_IN_MINUTES);
    const cookiesToSet = [
        { key: cookieKeys.landingPageKey, value: landingPage, domain: 'pleo.io' },
        { key: cookieKeys.rawLandingPageKey, value: rawLandingPage, domain: 'pleo.io' },
        { key: cookieKeys.landingLocale, value: landingLocale },
    ];
    cookiesToSet.forEach(({ key, value, domain }) => {
        js_cookie_1.default.set(key, value, {
            // Reset the session timer on every page load
            expires,
            domain,
        });
    });
    if (loggedInCurrently) {
        js_cookie_1.default.set(cookieKeys.previousSessionStatusKey, 'true', { expires: 365 });
    }
};
exports.updateSessionTrackingCookies = updateSessionTrackingCookies;
